import React, { useRef, useState } from "react";

const OnboardingStep6 = ({ activeItems, toggleSubMenu, handleNext }) => {
  const isActive = (item) => activeItems.includes(item);

  const handleToggle = (item) => {
    const groupItems = [
      "activity-0",
      "activity-1",
      "activity-2",
      "activity-3",
      "activity-4",
    ];
    groupItems.forEach((activeItem) => {
      if (isActive(activeItem)) {
        toggleSubMenu(activeItem);
      }
    });
    toggleSubMenu(item);
  };

  const groupItems = [
    "activity-0",
    "activity-1",
    "activity-2",
    "activity-3",
    "activity-4",
  ];

  const goalRef = useRef(null);
  const nameRef = useRef(null);
  const [isFormFilled, setIsFormFilled] = useState(false);

  const handleInputChange = () => {
    const personalGoal = goalRef.current.value;
    const patientName = nameRef.current.value;
    setIsFormFilled(personalGoal.trim() !== "" && patientName.trim() !== "");
  };

  const handleNextWithStorage = () => {
    const personalGoal = goalRef.current.value;
    const patientName = nameRef.current.value;
    localStorage.setItem("personal_goal", personalGoal);
    localStorage.setItem("patient_name", patientName);
    handleNext();
  };

  return (
    <div className="modal-container animated-onboarding onboarding-step6 fadeIn">
      <div className="modal-container-title heading fade1 typewriter-container">
        <span className="typewriter">This is it!</span>
      </div>
      <div className="modal-contect-title label fade2">
        <p>
          Everyone has something they’re looking forward to—whether it’s hiking,
          playing with your kids, or just moving without pain.
        </p>
        <h4>Let us know what matters most to you!</h4>
        <textarea
          className="goals"
          placeholder="Type your goal here (e.g., I want to go hiking again or play with my grandkids)"
          ref={goalRef}
          onChange={handleInputChange}
        ></textarea>
        <h4>What name should we use to cheer you on?</h4>
        <input
          type="text"
          className="input-name"
          placeholder=""
          ref={nameRef}
          onChange={handleInputChange}
        />
      </div>
      
      {isFormFilled && (
        <>
          <div className="nav-container fade-fast">
            <button className="btn-next next-btn" onClick={handleNextWithStorage}>
              Finish
            </button>
          </div>
          <div className="dot-container fade-fast">
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-checked"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default OnboardingStep6;
